import { PRODUCT_ACTIONS, API_ERROR } from '../utils/constants/ActionTypes';
import { SUBMISSION_MESSAGE_TYPE } from '../utils/helpers/utilityHelpers';
import { URL_PARAMS } from "../utils/constants/URL_Addresses";
import { POLLING, ACTION_TYPES, PRODUCT_SUBMISSION_TYPE } from '../utils/constants/AppConstants';
import {
    getUserProductListURL,
    getUserProductItemBySubmissionIdURL,
    getProductTestReportURL,
    getProductTestReportStatusURL,
    createProductURL,
    createFirstProductVersionURL,
    getUserProductListByUrlKeyURL,
    updateProductBySubmissionIdURL,
} from '../utils/urls/';
import { push } from 'react-router-redux';
import { 
    getUserProductListByUrlKey as getUserProductListByUrlKeyService,
    getUserProductItemBySubmissionIdforSP as getUserProductItemBySubmissionIdforSPService,
    updateProduct as updateProductService,
    sortProductVersions as sortProductVersionsService,
    getProductVersionCompatibilities as getProductVersionCompatibilitiesService,
    getUserProductPreview as getUserProductPreviewService,
    getUserProductPreviewForAdmin as getUserProductPreviewForAdminService} from '../services/products';

import loadingURL from './url';
import { errorNotification} from './notifications';
import { REST_URLS_PRODUCT_API } from '../utils/constants/URL_Addresses';
import { FETCH_PUT_OPTIONS, FETCH_GET_OPTIONS, FETCH_POST_OPTIONS} from '../utils/constants/RestHelpers';
import { NORMALIZE_CATEGORIES } from '../utils/helpers/utilityHelpers';
import { clearProductFormErrors, formError, productSubmitSuccessNotification } from './notifications';
import api from '../utils/apiFetch';

/* ----- Base Actions ----- */


const recieveUserProductList = (products) => ({
    type    : PRODUCT_ACTIONS.GET_USER_PRODUCT_LIST,
    payload : products,
})

export const getUserProductList = (offset=0, limit="-1", type="all", style="summary") => (dispatch) => {
    //Added so that the summary details related to packages are fetched only on the associated pages
    const validPathsForExtensionSummary = ['/extensions/', '/extensions', '/sharedpackages/', '/sharedpackages', '/themes/', '/themes'];
    if(!validPathsForExtensionSummary.includes(window.location.pathname)){
        style = false;
    }
    const url = getUserProductListURL(offset, limit, type, style);
    return api(url, {...FETCH_GET_OPTIONS}, dispatch)
        .then((products)=>{
            dispatch(loadingURL(url, 'GET', 'success'));
            return dispatch(recieveUserProductList(products));
        })
        .catch((error)=>{})
}

export const getUserProductListByUrlKey = url_key => ({
    type    : PRODUCT_ACTIONS.GET_USER_PRODUCT_LIST_BY_URL_KEY,
    meta    : {url_key},
    payload : getUserProductListByUrlKeyService(url_key)
});


const productListByUrlKeyAction = (products) => ({
    type    : PRODUCT_ACTIONS.GET_USER_PRODUCT_LIST_BY_URL_KEY,
    payload : products,
});

export const getProductListByUrlKey = (url_key="") => (dispatch) => {
    const url = getUserProductListByUrlKeyURL(url_key);
    return api(url, {...FETCH_GET_OPTIONS}, dispatch)
        .then((products)=>{
            dispatch(loadingURL(url, 'GET', 'success'));
            return dispatch(productListByUrlKeyAction(products));
        })
        .catch(()=>{})
}

const createProductVersionAction = (products) => ({
    type    : PRODUCT_ACTIONS.CREATE_USER_PRODUCT_ITEM,
    payload : products,
})

//why is this logic all in the action!? instead of the services like the rest of the application?//
//TODO//clean this up so it follows the same structure as the rest of the application//JRP//
export const createProductVersion = (data, isFirstVersion, options={}) => dispatch => {
    let url = createProductURL();
    let method = FETCH_POST_OPTIONS;
    if (isFirstVersion) {
        url = createFirstProductVersionURL();
        method = FETCH_PUT_OPTIONS;
    }
    return api( url, {...method, body:JSON.stringify(data)} , dispatch)
    .then((product)=>{
        if(options.hasOwnProperty('formName') && options.hasOwnProperty('url_key')) {
            dispatch(clearProductFormErrors(options.url_key));
        }

        // check if we are getting back the product or an array of errors :(
        let batchError = {} //get the first since we don't do batch posts on the front-end
        // check for any errors in a 200 response. Yes, that is correct.
        if(Array.isArray(product)) {
            batchError = product.find((el)=>  {
                    return (
                            (typeof el === 'object') &&
                            el.hasOwnProperty("code") &&
                            el.code !== 200 &&
                            el.hasOwnProperty("message")
                        );
            });
            
        }
        // If we have a populated object then throw an errow
        if( batchError && Object.keys(batchError).length) {
            throw new Error(JSON.stringify(batchError)); 
        }
        
        dispatch(createProductVersionAction(product));
        return product
    })
    .catch((response)=>{
        if(response.status) {
            // handle 500 errors or errors other than 4xx
            // TODO dispatch global errors if needed
            // More work needs to be done.
            throw new Error(JSON.stringify(response));
        } else {
            // 4xx errors. These will need to be displayed in the form area per product/form
            const parsedMessage = response[0].message.toString();

            if(options.hasOwnProperty('formName')) {
                dispatch(formError(options.formName, options.url_key, parsedMessage));
            }

            throw Error(JSON.stringify(parsedMessage));
        }
    })
};

export const getUserProductBySubmissionId = (submission_id, navigate=null) => dispatch => {
    const url = getUserProductItemBySubmissionIdURL(submission_id);
    return api( url, FETCH_GET_OPTIONS, dispatch)
    .then((product)=>{
        dispatch(loadingURL(url, 'GET', 'success'));
        return dispatch(updateSingleProductAction(product));
    })
    .then((action) => { 
        if(navigate !== null){
            const type = action.payload.type;
            dispatch(push(`/${type}s` + navigate.url.replace(URL_PARAMS.NAVIGATION_KEY, `/${submission_id}`)))
        }
        return action.payload;
    })
}

export const updateProduct = (data, navigate=null) => dispatch => dispatch({
    type: PRODUCT_ACTIONS.UPDATE_USER_PRODUCT_ITEM,
    payload: updateProductService(data)
}).then( ({value:[{submission_id, type}]}) => {
    if (navigate !== null)
        dispatch(push(`/${type}s` + navigate.url.replace(URL_PARAMS.NAVIGATION_KEY, `/${submission_id}`)));
}).catch( error => { dispatch(errorNotification(error))});

export const getProductVersionCompatibilities = (submissionId="", platform="", edition="") => ({
    type    : PRODUCT_ACTIONS.GET_PRODUCT_VERSION_COMPATIBILITIES,
    payload : getProductVersionCompatibilitiesService(submissionId, platform, edition)
});

export const getUserProductPreview = (submission_id) => ({
    type: PRODUCT_ACTIONS.GET_USER_PRODUCT_PREVIEW,
    payload: getUserProductPreviewService(submission_id)
});

export const getUserProductPreviewForAdmin = (submission_id) => ({
    type: PRODUCT_ACTIONS.GET_USER_PRODUCT_PREVIEW_FOR_ADMIN,
    payload: getUserProductPreviewForAdminService(submission_id)
});


/* ---- Navigation Actions ------ */

//TEMP : hotfix for SP version details to work
export const getUserProductBySubmissionIdForSP = submissionId => {
    return {
        type    : PRODUCT_ACTIONS.GET_USER_PRODUCT_ITEM_BY_ID_FOR_SP,
        payload : getUserProductItemBySubmissionIdforSPService(submissionId)
    };
};

export const sortProductVersions = (sku, order , elm) => {
    return {
        type    : PRODUCT_ACTIONS.SORT_USER_PRODUCT_VERSIONS,
        payload : sortProductVersionsService(sku, order , elm)
    }
};

export const updateSingleProductAction = (product) => (
    {
        type    : PRODUCT_ACTIONS.UPDATE_USER_PRODUCT_ITEM,
        payload : product,
    }
)

export const productErrorAction = (error) =>({
    type: API_ERROR.PRODUCT,
    payload: error
})

export const updateSingleProduct = (data, submissionId, options={}) => (dispatch) => {
    const url = updateProductBySubmissionIdURL(submissionId);
    return api(url, {...FETCH_PUT_OPTIONS, body:JSON.stringify(data)}, dispatch)
        .then((product) => {
            if(options.hasOwnProperty('formName')) {
                dispatch(clearProductFormErrors(submissionId));
            }
            // notification for technical/marketing. The notification is different for extensions/themes and shared packages
            if( options.hasOwnProperty('productType') &&
                options.productType &&
                data.hasOwnProperty('action') &&
                ( 
                    ( data.action.hasOwnProperty(ACTION_TYPES.MARKETING) &&
                      data.action[ACTION_TYPES.MARKETING] === PRODUCT_SUBMISSION_TYPE.SUBMIT ) ||
                    ( data.action.hasOwnProperty(ACTION_TYPES.TECHNICAL) &&
                      data.action[ACTION_TYPES.TECHNICAL] === PRODUCT_SUBMISSION_TYPE.SUBMIT )
                )
            ) {
                const productType = options.productType;
                const actionType = (data.action.hasOwnProperty(ACTION_TYPES.MARKETING)) ? ACTION_TYPES.MARKETING : ACTION_TYPES.TECHNICAL;
                const message = SUBMISSION_MESSAGE_TYPE({productType, actionType})
                dispatch(productSubmitSuccessNotification(submissionId, message))
            }
            return dispatch(updateSingleProductAction(product));
        })
        .catch((response)=>{
            if(response.status) {
                // handle 500 errors or errors other than 4xx
                // TODO dispatch global errors if needed
                // More work needs to be done.
                throw new Error(JSON.stringify(response));
            } else {
                // 4xx errors. These will need to be displayed in the form area per product/form
                const payload = {
                    submission_id:submissionId,
                    response
                }
                
                if(options.hasOwnProperty('formName')) {
                    dispatch(formError(options.formName, submissionId, response));
                }
               
                // TODO dispatch global errors if needed
                dispatch(productErrorAction(payload));
                throw new Error(JSON.stringify(response));
            }
        })
};

const getProductCategoriesAction = (data) => (
    {
        type    : PRODUCT_ACTIONS.GET_PRODUCT_CATEGORIES,
        payload : data,
    }
);

export const getProductCategories = () => (dispatch) => {
    return api(REST_URLS_PRODUCT_API.GET_PRODUCT_CATEGORIES, {...FETCH_GET_OPTIONS}, dispatch)
            .then((categories)=>{
                //normalize data
                const normalizedData = NORMALIZE_CATEGORIES(categories);
                return dispatch(getProductCategoriesAction(normalizedData));
            })
            .catch((error)=>{})
}


export const deleteGalleryImage = (uploadId, submissionId, options={}) => (dispatch, getState) =>{
    const currentState = getState();
    const product = currentState.products.products.find((product)=>(product.submission_id === submissionId));
    const gallery_images = product.media_artifacts.gallery_images
        .filter((item)=>(item.file_upload_id !== uploadId))
        .map((item)=>({file_upload_id:item.file_upload_id}));
    const data = {
        submission_id:submissionId,
        "media_artifacts": {
            gallery_images
        }
    }
    if(options.hasOwnProperty('action')) {
        data.action = options.action;
    }
    return dispatch(updateSingleProduct(data, submissionId, options));
}


export const deleteIconImage = (uploadId, submissionId, options={}) => (dispatch) => {
    const data = {
        submission_id:submissionId,
        "media_artifacts": {
        icon_image: {}
        }
    };
    if(options.hasOwnProperty('action')) {
        data.action = options.action;
    }
    return dispatch(updateSingleProduct(data, submissionId, options))
}


export const polling = (data) => {
    return {
        type : POLLING,
        meta : data
    };
};

const getProductTestReportsAction = (reports) => { 
    return {
        type    : PRODUCT_ACTIONS.GET_PRODUCT_TEST_REPORTS,
        payload : reports,
    };
}

export const getProductTestReports = (submissionId) => (dispatch)=> {
    const url = getProductTestReportStatusURL(submissionId);
    return api(url, {...FETCH_GET_OPTIONS}, dispatch)
    .then((data) => {
       dispatch(loadingURL(url, 'GET', 'success'));
       return dispatch(getProductTestReportsAction(data));
    })
    .catch((error) => {
       throw new Error(JSON.stringify(error));
    });
}

const productTestReportAction = (submissionId, testName, testId, data) => {
    return {
        type    : PRODUCT_ACTIONS.GET_PRODUCT_TEST_REPORT,
        payload : {
            submissionId,
            testName,
            testId,
            data,
        }
    }
}

export const getProductTestReport = (submissionId, testName, testId) => (dispatch)=> {
    const url = getProductTestReportURL(submissionId, testName, testId);
    return api(url, {...FETCH_GET_OPTIONS}, dispatch)
    .then((data) => {
        dispatch(loadingURL(url, 'GET', 'success'));
        return dispatch(productTestReportAction(submissionId, testName, testId, data))
    })
    .catch((error) => {
        throw new Error(JSON.stringify(error));
    })
}
